/**
 * Created by 叶子 on 2017/7/30.
 * 接口地址配置文件
 */

//easy-mock模拟数据接口地址
const EASY_MOCK = 'https://www.easy-mock.com/mock';
const MOCK_AUTH = EASY_MOCK + '/597b5ed9a1d30433d8411456/auth';// 权限接口地址
export const MOCK_AUTH_ADMIN = MOCK_AUTH + '/admin';// 管理员权限接口
export const MOCK_AUTH_VISITOR = MOCK_AUTH + '/visitor';// 访问权限接口





// WEBPACK FOOTER //
// ./src/axios/config.js